import "./MatchupCard.css";

const record = (w, l) => (w == null || l == null ? "—" : `${w}–${l}`);

// Projected score: .7 and above rounds up, otherwise down.
const projScore = (v) => {
  const tenths = Math.round(v * 10);
  return tenths % 10 >= 7 ? Math.ceil(tenths / 10) : Math.floor(tenths / 10);
};

// ESPN "5:42 - 3rd" -> "Q3 5:42", "End of 3rd" -> "END Q3".
export const liveClock = (d) => {
  if (!d) return "LIVE";
  const q = (o) => (/^\d/.test(o) ? `Q${parseInt(o, 10)}` : o.toUpperCase());
  const m = d.match(/^(\d+(?::\d+)?(?:\.\d)?) - (\S+)$/);
  if (m) return `${q(m[2])} ${m[1]}`;
  const e = d.match(/^End of (\S+)$/i);
  return e ? `END ${q(e[1])}` : d.toUpperCase();
};

function Team({ code, logo, wins, losses, testId, b2b }) {
  return (
    <div className="nba-team">
      <img src={logo} alt={code} className={`nba-logo ${b2b ? "nba-logo-b2b" : ""}`} loading="lazy"
        title={b2b ? `${code} back-to-back: played the previous day` : undefined} data-testid={b2b ? `${testId}-b2b` : undefined} />
      <strong>{code}</strong>
      <span className="nba-record" data-testid={testId}>{record(wins, losses)}</span>
    </div>
  );
}

export function MatchupCard({ game, selected = false, onSelect }) {
  const final = game.status === "final" && game.awayScore != null && game.homeScore != null;
  const ppd = game.status === "ppd";
  const live = game.status === "live";
  return (
    <button type="button" data-testid={`matchup-card-${game.id}`} className={`nba-matchup ${final ? "is-final" : ""} ${live ? "is-live" : ""} ${selected ? "is-selected" : ""}`}
      aria-pressed={selected} aria-label={`${game.awayCode} at ${game.homeCode}`} onClick={() => onSelect?.(game.id)}>
      <Team code={game.awayCode} logo={game.awayLogo} wins={game.awayWins} losses={game.awayLosses} testId={`away-record-${game.id}`} b2b={game.awayB2b} />
      {live ? (
        <div className="nba-center nba-center-final nba-center-live" data-testid={`matchup-live-${game.id}`}>
          <span className="nba-live-clock" data-testid={`matchup-clock-${game.id}`}><i aria-hidden="true" />{liveClock(game.liveDetail)}</span>
          <span className="nba-score" data-testid={`matchup-center-${game.id}`}>{game.awayScore ?? 0} : {game.homeScore ?? 0}</span>
        </div>
      ) : final ? (
        <div className="nba-center nba-center-final">
          <span className="nba-final-label" data-testid={`matchup-top-${game.id}`}>FINAL</span>
          <span className="nba-score" data-testid={`matchup-center-${game.id}`}>{game.awayScore} : {game.homeScore}</span>
        </div>
      ) : (
        <div className="nba-center">
          <span className="nba-date" data-testid={`matchup-date-${game.id}`}>{game.startDate}</span>
          <span className="nba-time" data-testid={`matchup-top-${game.id}`}>{ppd ? "PPD" : game.startTime}</span>
          {game.projAway != null && game.projHome != null && !ppd && (
            <span className="nba-proj" data-testid={`matchup-proj-${game.id}`} title="Projected score (rotation-adjusted team totals)">
              {projScore(game.projAway)} - {projScore(game.projHome)}
            </span>
          )}
          <span className="nba-h2h" data-testid={`matchup-h2h-${game.id}`}>H2H {game.h2hAwayWins ?? 0}-{game.h2hHomeWins ?? 0}</span>
        </div>
      )}
      <Team code={game.homeCode} logo={game.homeLogo} wins={game.homeWins} losses={game.homeLosses} testId={`home-record-${game.id}`} b2b={game.homeB2b} />
    </button>
  );
}

export function MatchupSkeleton() {
  return <div className="nba-matchup nba-skeleton" aria-hidden="true" />;
}
